const metrics = [
  { value: '100+', label: 'Guides' },
  { value: '60+', label: 'Articles' },
  { value: '100+', label: 'Long-tail Pages' },
  { value: '2026', label: 'Updated Resources' },
];

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Urban%20streetwear%20fashion%20flatlay%20on%20concrete%20surface%20featuring%20dark%20denim%20jacket%20draped%20over%20premium%20sneakers%20with%20baseball%20cap%20and%20aviator%20sunglasses%20alongside%20leather%20backpack%20soft%20directional%20lighting%20from%20window%20creating%20dramatic%20yet%20warm%20atmosphere%20modern%20editorial%20product%20photography%20muted%20earth%20tones&width=1600&height=700&seq=cta-streetwear-v2&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/70"></div>

      <div className="relative z-10 container-custom text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          Ready To Explore The Complete Superbuy Spreadsheet?
        </h2>
        <p className="text-background-100/80 max-w-lg mx-auto text-sm md:text-base mb-8">
          Save hours of research, find organized resources, and compare better options — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            Superbuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/20 transition-all cursor-pointer whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {metrics.map((m) => (
            <div key={m.label} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{m.value}</p>
              <p className="text-background-100/60 text-xs mt-1">{m.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}